import { combineReducers } from 'redux';
import { authentication } from './AuthReducer';
import { driverPicker } from './DriversReducer';
import { createDReducer } from './CreateDReducer';
import { get_unconfirmed } from './UnconfirmedReducer';
import { driversBC } from './DriversByC';
import { certificatesBD } from './CertificatesByD';
import { certificateDetails } from './CertificateDetails';
import {createCert} from './CreateCReducer';
const RootReducer = combineReducers({
    authentication,
    createDReducer,
    driverPicker,
    get_unconfirmed,
    driversBC,
    certificatesBD,
    certificateDetails,
    createCert
});

export default RootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js